// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"8e80ab27","323":"8e80ab27","653":"cf19736e","921":"cf19736e","998":"8e80ab27"}[chunkId] + ".chunk.css";
};